import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
    name: 'NavigateBack',
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    href;
    @Prop({ required: true })
    label;
}
